import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { templateDescriptionRelayFragment$key } from "@/__generated__/templateDescriptionRelayFragment.graphql";
import { SanitizedRichText } from "@/components/confluence/util/sanitized-rich-text";

interface TemplateDescriptionProps {
    template: templateDescriptionRelayFragment$key;
}

const TemplateDescriptionRelayFragment = graphql`
    fragment templateDescriptionRelayFragment on ContentPlatformTemplate {
        aboutThisTemplate
    }
`;

export const TemplateDescription = ({ template }: TemplateDescriptionProps) => {
    const { aboutThisTemplate } = useFragment(
        TemplateDescriptionRelayFragment,
        template
    );

    if (!aboutThisTemplate) {
        return null;
    }

    return (
        <section data-testid="confluence-template-details-template-description">
            <SanitizedRichText innerHTML={aboutThisTemplate} />
        </section>
    );
};
